// react
import React, { useState, useEffect, useContext, useRef } from 'react';
import useForm from 'react-hook-form';

// react component for creating dynamic tables
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';

//graph
import LineGraph from '../../../beaktMatriz/views/Dashboard/Graficos/LineGraph';

// @material-ui/core | components 
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

// icons | @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import { useReactToPrint } from 'react-to-print';

// services
import { SessionContext } from "beaktShared/services/session";
import { useGetApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import stylesPrint from "assets/jss/BeaktClinic/views/Venda/contratoVenda.js";

// images
import logoDrDiabetes from 'assets/img/logoDrDiabetes.png';

const useStyles = makeStyles(styles);
const useStylesPrint = makeStyles(stylesPrint);

export default function GestaoAnamnesePrint({ item, handleView }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const { setValue } = useForm({mode: "onChange"});
    const classesPrint = useStylesPrint();
    const session = useContext(SessionContext);
    const endPoint = "FichaAnamnese/";

    useEffect(() => {
        if(!item.fichaAnamneseId) {
            return;
        }
        else{
            let endPointGet = endPoint + "byFichaId/" + item.fichaAnamneseId;
            UseGetApiSimple(endPointGet, 0).then(result => {
                if (result.status == 200) {
                    loadFichaAnamnese(result.data);
                }
            });
        }
    }, [item]);

    const [questionario, setQuestionario] = React.useState({});
    const [clienteNome, setClienteNome] = React.useState('');
    const [clienteCPF, setClienteCPF] = React.useState('');
    const [clienteEmail, setClienteEmail] = React.useState('');
    const [clienteCelular, setClienteCelular] = React.useState('');
    const [clienteDataNascimento, setClienteDataNascimento] = React.useState('');
    const [clienteSexo, setClienteSexo ] = React.useState('');
    const [dataRegistro, setDataRegistro] = React.useState('');
    const [usuarioCadastro, setUsuarioCadastro] = React.useState('');
    
    const loadFichaAnamnese = (dados) => {
        if (dados !== null) {
            setValue('clienteId', item.clienteId);
            setClienteNome(item.clienteNome);
            setClienteCPF(dados.clienteCPF);
            setClienteEmail(dados.clienteEmail);
            setClienteCelular(dados.clienteCelular);
            setClienteDataNascimento(dados.clienteDataNascimento);
            setClienteSexo(dados.clienteSexo);
            setQuestionario(dados.printPergunta);
            setDataRegistro(dados.dataCadastroFormatado);
            setUsuarioCadastro(dados.usuarioNome);
        }
    }
    
    //Função Imprimir
    const refImprimir = useRef();
    const handlePrint = useReactToPrint({
        content: () => refImprimir.current,
        copyStyles: true,
        documentTitle: "",
    });

    const handleCustomPrint = () => {
        handlePrint();
        document.title = "Beakt";
    };
    
    const handleViewForm = () => {
        handleView(false);
    };

    return (
        <>
            <div className="no-print">
                    <div style={{textAlign:'center'}}>
                        <div>
                            <Button onClick={() => handleViewForm()} color="#efefef" className={classes.updateProfileButton}>
                                {t('label.return')}
                            </Button>
                            <Button color="info" onClick={handleCustomPrint}> 
                                {t('button.print')} 
                            </Button>
                        </div>
                    </div>
            </div>

            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('label.anamnesis_record')}</h4>
                        </CardHeader>
                        <CardBody>
                            
                            <div 
                                id="div_Resultado"  
                                ref={refImprimir} 
                                className="allowPrint"
                                style={{ 
                                    color: 'black',
                                    maxWidth: '900px',
                                    margin: '0 auto !important',
                                    border: '1px solid rgb(206, 206, 206)', 
                                    background: '#FFFFFF', 
                                    padding: '10px 15px', 
                                    fontWeight: '400',
                                    width:'98% !important' }}
                            >

                                <table style={{ width: '98%', textAlign: 'center', paddingLeft: '15px !important' }}>
                                    <thead>
                                        <tr>
                                            <th>
                                                <div style={{borderTop:'solid 1px black',borderBottom:'solid 1px black'}}>
                                                    <GridContainer className={classes.boxAvaliacao} alignItems={'center'} style={{margin:'10px 0'}}>
                                                        <GridItem  xs={6} md={6} style={{paddingLeft:'20px',borderRight:'solid 1px black'}}>
                                                            <div style={{textAlign:'center'}}>
                                                                <img src={logoDrDiabetes} style={{maxWidth:'380px'}}/>
                                                            </div>
                                                        </GridItem>
                                                        <GridItem  xs={3} md={3} style={{textAlign:'center'}}>
                                                            UNIDADE: <strong>{session.estabelecimentoDescricao}</strong>
                                                        </GridItem>
                                                    </GridContainer>
                                                </div>

                                                <GridContainer className={classes.boxAvaliacao} alignItems={'center'} style={{margin:'10px 0'}}>
                                                    <GridItem  xs={4} md={4} style={{paddingLeft:'20px'}}>
                                                        <div style={{textAlign:'center'}}>
                                                            <h3 className={classes.titleStep}>{t('label.anamnesis_client')}: </h3>
                                                        </div>
                                                    </GridItem>
                                                    <GridItem  xs={8} md={8} style={{textAlign:'center', padding:'0 10px'}}>
                                                        <p style={{ margin: '0', padding: '0' }}>
                                                            <strong>{clienteNome}</strong>
                                                        </p>
                                                        <p style={{ margin: '0', padding: '0' }}>
                                                            <strong> CPF: </strong> {clienteCPF} | 
                                                            <strong> Celular: </strong> {clienteCelular} | 
                                                            <strong> E-mail: </strong>{clienteEmail}
                                                        </p>
                                                    </GridItem>
                                                </GridContainer>
                                                <hr className="linha"/>
                                    
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <div>

                                            <GridContainer 
                                                className={classes.boxPrint} 
                                                alignItems={'center'} 
                                                style={{ margin:'5px 10px', textAlign: 'left' }}>
                                                <GridItem  xs={6} md={6}>
                                                    <div>
                                                        <h5 style={{ textTransform: 'uppercase', color: '#5d5d5d', fontSize: '0.875rem' }}>
                                                            Data de nascimento: <strong style={{ fontWeight: 'bold', color: '#535353'}}>{clienteDataNascimento}</strong>
                                                        </h5>
                                                    </div>
                                                </GridItem>
                                                <GridItem  xs={6} md={6} >
                                                    <div>
                                                        <h5 style={{ textTransform: 'uppercase', color: '#5d5d5d', fontSize: '0.875rem' }}>
                                                            Sexo: <span style={{ fontWeight: 'bold', color: '#535353'}}>{clienteSexo}</span>
                                                        </h5>
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha"/>

                                            <GridContainer 
                                                className={classes.boxPrint} 
                                                alignItems={'center'} 
                                                style={{ margin:'5px 10px', textAlign: 'left' }}>
                                                <GridItem  xs={6} md={6} >
                                                    <div>
                                                        <h5 style={{ textTransform: 'uppercase', color: '#5d5d5d', fontSize: '0.875rem' }}>
                                                            Registrado em: <span style={{ fontWeight: 'bold', color: '#535353'}}>{dataRegistro}</span>
                                                        </h5>
                                                    </div>
                                                </GridItem>
                                                <GridItem  xs={6} md={6} >
                                                    <div>
                                                        <h5 style={{ textTransform: 'uppercase', color: '#5d5d5d', fontSize: '0.875rem' }}>
                                                            Biomédico: <span style={{ fontWeight: 'bold', color: '#535353'}}>{usuarioCadastro}</span>
                                                        </h5>
                                                    </div>
                                                </GridItem>
                                            </GridContainer>

                                            <hr className="linha"/>

                                            {
                                                questionario.length > 0 && 
                                                questionario.map(printPergunta => (
                                                    <>
                                                        <GridContainer 
                                                            key={printPergunta.ordem}
                                                            className={classes.boxPrint} 
                                                            alignItems={'center'} 
                                                            style={{ margin:'5px 10px', textAlign: 'left' }}>
                                                            <div style={{ width: '98%' }}>
                                                                <GridItem  xs={12} md={12}>
                                                                    <h4 style={{ textTransform: 'uppercase', color: '#5d5d5d', fontSize: '0.875rem' }}>
                                                                        {printPergunta.descricao}
                                                                    </h4>
                                                                    {
                                                                        printPergunta.textoOrientacao !== "" && 
                                                                        <span style={{ color: '#666666', fontStyle: 'italic' }}>
                                                                            {printPergunta.textoOrientacao}
                                                                        </span>
                                                                    }
                                                                    <h5 style={{ fontWeight: 'bold', color: '#535353' }}>
                                                                        {
                                                                            printPergunta.printResposta.length > 0 &&
                                                                            <>
                                                                                {
                                                                                    printPergunta.printResposta.map(respostas => (
                                                                                        <div style={{ width: '98%' }}>
                                                                                            {
                                                                                                respostas.tipoResposta === 0 ?
                                                                                                (
                                                                                                    <>
                                                                                                    {
                                                                                                        respostas.checked === true ?
                                                                                                        (<span>( X ) </span>) : 
                                                                                                        (<span>(<span style={{ color: '#FFFFFF' }}> X </span>) </span>)
                                                                                                    }
                                                                                                    {
                                                                                                        respostas.checked === true ?
                                                                                                        (
                                                                                                            <span style={{ fontWeight: 'bold' }}>{respostas.descricao}</span>
                                                                                                        ) :
                                                                                                        (
                                                                                                            <span style={{ fontWeight: 'normal' }}>{respostas.descricao}</span>
                                                                                                        )
                                                                                                    }
                                                                                                    </>
                                                                                                ) :
                                                                                                (
                                                                                                    <>
                                                                                                        <span>
                                                                                                            {
                                                                                                                respostas.valorResposta !== null ?
                                                                                                                (<>{respostas.valorResposta}</>)
                                                                                                                :
                                                                                                                (<div style={{ height: '30px', borderBottom: '1px solid #e5e5e5' }}></div>)
                                                                                                            }
                                                                                                        </span>
                                                                                                    </>
                                                                                                )
                                                                                            }
                                                                                        </div>
                                                                                    ))
                                                                                }
                                                                            </>
                                                                        }
                                                                    </h5>
                                                                </GridItem>
                                                            </div>
                                                        </GridContainer>

                                                        <hr className="linha"/>
                                                    </>
                                                ))
                                            }

                                        </div>
                                    </tbody>

                                </table>

                            </div>

                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

        </>
    );
}